import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarIcon, X } from "lucide-react";

const toISO = (d) => (d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "");
const fmt = (s) => (s ? new Date(s + "T00:00:00").toLocaleDateString("en-GB") : "");

export function DatePicker({ value, onChange, placeholder = "Pick date", testid, className }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`relative inline-block ${className || "w-40"}`}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" data-testid={testid} className={`w-full justify-start font-normal ${value ? "pr-8" : ""} ${!value ? "text-muted-foreground" : ""}`}>
            <CalendarIcon className="mr-2 h-4 w-4 opacity-70 shrink-0" />
            <span className="truncate">{value ? fmt(value) : placeholder}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={value ? new Date(value + "T00:00:00") : undefined}
            onSelect={(d) => { onChange(toISO(d)); setOpen(false); }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {value && (
        <button
          type="button"
          data-testid={testid ? `${testid}-clear` : undefined}
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-10 text-muted-foreground hover:text-foreground"
          aria-label="Clear date"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
